import LoginContainer from 'containers/LoginContainer';

type Props = {};

export default function LoginPage({}: Props) {
  return <LoginContainer />;
}
